<template>
  <v-card>
    <v-card-title class="primary--text">Are you sure you want to delete this item?</v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="closeDelete">Cancel</v-btn>
      <v-btn color="primary" text @click="deleteItemConfirm">OK</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "DeleteDialog",
  props: {
    closeDelete: Function,
    deleteItemConfirm: Function
  }
}
</script>

<style scoped>

</style>